module.exports = "/images/search.svg?146e7f7a8a0968d2ac4ea2e7162d1150";